import { render, staticRenderFns } from "./BasicToasts.vue?vue&type=template&id=5525a922"
import script from "./BasicToasts.vue?vue&type=script&lang=js"
export * from "./BasicToasts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports